import LocateMe from './LocateMe';

export default LocateMe;